interface Config {
  logoutRedirectUrl: string;
  supportCentreUrl: string;
}

const config: Config = {
  // Currently unread — nothing imports this field. The real post-logout
  // destination is built by `selectLogoutUri`, which appends
  // `post_logout_redirect_uri=<baseUri>` to aiakos' logout endpoint, so users
  // land back on the app and are bounced to the login page. Kept as the
  // marketing site so the value is right if it ever gets wired up.
  logoutRedirectUrl: "https://accesso.ai",
  supportCentreUrl: "https://support.dexibit.com",
};

export default config;
